export const MAX_NAME_LENGTH = 70;
export const MAX_TEXT_LENGTH = 254;
